// @flow
import * as React from 'react';
import styled from 'styled-components';

const AlertWrapper = styled.div`
	height: 400px;
    justify-content: center;
    align-items: center;
    display: flex;
    font-size: 22px;
    font-weight: bold;
`;

type Props = {
	text: string,
};

export const AlertScreen = ({ text }: Props) => (
	<AlertWrapper>{text}</AlertWrapper>
);

export default AlertScreen;


// WEBPACK FOOTER //
// ./src/components/AlertScreen/index.js